import React, { useCallback, useEffect, useState } from 'react'
import { PulseLoader } from 'react-spinners';
import Table from '../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { GetMenuApi } from '../redux/actions/Menu/GetListAction';
import { useLocation } from 'react-router-dom';

const MenuManagement = () => {
    const dispatch = useDispatch()
    const statusTerm = useSelector((state) => state.status.term);
    const searchTerm = useSelector((state) => state.search.term);
    const columns = ["Food Name", "Food Type", "Price", "Day", "Action"]
    const dayTerm = useSelector((state) => state.day.term);
    const {
        response,
        error,
        loading
    } = useSelector((state) => state.menuList);
    const [currentPage, setCurrentPage] = useState(1);
    const location = useLocation();

    const [totalPages, setTotalPages] = useState(1);
    const [items, setItems] = useState(5);

    const [limit, setLimit] = useState(5);

    const [deletedMenu, setDeletedMenu] = useState(false);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchMenu = useCallback(() => {
        dispatch(GetMenuApi(currentPage, limit, statusTerm, searchTerm, dayTerm));
    }, [
        dispatch,
        currentPage,
        limit,
        statusTerm,
        searchTerm,
        dayTerm,
        location.pathname,
    ]);

    useEffect(() => {
        fetchMenu()
    }, [currentPage,
        limit,
        statusTerm,
        searchTerm,
        dayTerm, deletedMenu])

    useEffect(() => {
        setCurrentPage(1);
    }, [location.pathname, dayTerm, statusTerm, searchTerm]);

    useEffect(() => {
        if (response?.status === true) {
            setTotalPages(response?.data?.totalPages);
            setCurrentPage(response?.data?.currentPage);
            setItems(response?.data?.totalItems)
        }
    }, [response])
    return (
        <>
            {
                loading
                    ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <PulseLoader size={25} color="#0f0a30" />
                        </div>
                    ) : error ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <p className="text-danger">Something went wrong</p>
                        </div>
                    ) : (
                        <Table
                            title='Menu'
                            tableData={response?.data
                                ? {
                                    ...response.data,
                                    list: response.data.list?.map((menu) => ({
                                        ...menu,
                                        // Transform number to readable text for display
                                        category: menu.category === 0 ? "Veg" : "Non-Veg",
                                        day:
                                            menu.day === 0
                                                ? "Monday"
                                                : menu.day === 1
                                                    ? "Tuesday"
                                                    : menu.day === 2
                                                        ? "Wednesday"
                                                        : menu.day === 3
                                                            ? "Thursday"
                                                            : menu.day === 4
                                                                ? "Friday"
                                                                : menu.day === 5
                                                                    ? "Saturday"
                                                                    : "Sunday",
                                    })),
                                }
                                : null}
                            limit={limit}
                            items={items}
                            columns={columns}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            statusTerm={statusTerm}
                            handlePageChange={handlePageChange}
                            setDeletedMenu={setDeletedMenu}

                        />

                    )}

        </>
    )
}

export default MenuManagement